import React, { useCallback, useContext } from 'react';
import { LangContext } from "../../../store/lang-context";
import styles from './Loader.module.css';

function Loader(props) {

    // Props
    const { classes, loadingMessage } = props

    // Context
    const { activeLang } = useContext(LangContext)

    // Helper Functions
    const getClasses = useCallback(() => classes ? `${classes} ${styles['loader']}` : styles['loader'], [])

    return (
        <div className={getClasses()}>
            <div className={styles['abstract-container']}>
                <div className={styles['rotating-ring']}></div>
                <div className={styles['expanding-lines']}></div>
            </div>
            <p className={styles['loader-text']}>
                {loadingMessage && (activeLang ? loadingMessage.en : loadingMessage.sp)}
                {!loadingMessage && (activeLang ? 'Loading Data...' : 'Recolectando Datos...')}
            </p>
        </div>
    );
}

export default Loader;
